<style lang="less">
.spanPoptip .ivu-poptip-popper {
  left: -120px !important;
}

.spanPoptip .ivu-poptip-popper .ivu-poptip-arrow {
  left: 172px !important;
}

.spanPoptip .ivu-poptip-body {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
<template>
  <div>
    <div style="background-color: #fff;;" v-if="!info && ipt != 'examination' && ipt != 'examination2'">
      <div v-if="ipt == 'home' && dateurl != ''"
        style=" min-width: 1200px;display: flex;justify-content: center;overflow: hidden;height: 50px;cursor: pointer;"
        @click="carousel_click()">
        <img style="width:1920px; height: 50px; margin: 0 auto;" :src="dateurl" alt="">
      </div>
      <div class="header">
        <div style="float: left;cursor: pointer;" @click="quyht()">
          <img style="height: 60px;" src="../../../static/images/logo(4).png" alt="" />
        </div>
        <div class="headerright">
          <span style=" font-size: 17px; font-weight: 500;color:#000;float: left;height: 100%;line-height: 48px;">
            <img src="../../../static/images/xiaotubiao/客服热线1.png" alt="" style="width: 24px; margin-right: 5px" />
            客服热线： 13165127159
          </span>

          <div v-if="!sendsystem" style="float: right;"><el-button v-if="ipt != 'SignIn'" type="success" round
              style="float: right;margin-top: 6px;font-size: 16px;" @click="denglu">登录</el-button></div>
          <div v-else class="right-menu" style="line-height: 48px;">
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
              <div class="avatar-wrapper" style="height: 100%;">
                <img style="float: left;margin-top: 7px;width:30px;height:30px;vertical-align: middle;border-radius: 15px;
                                margin-right: 5px;" :src="imgurl == null || imgurl == 'null' ? imgtourl : imgurl"
                  alt="">
                <span class="spn" style="">{{ realname == null || realname == 'null' ? '新用户' : realname }}</span>
                <i class="el-icon-caret-bottom" style="float: right;margin-top: 14px;" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <a target="_blank" @click="grzx()">
                  <el-dropdown-item>个人中心</el-dropdown-item>
                </a>
                <el-dropdown-item divided @click.native="logout">
                  <span style="display:block;">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div v-if="ipt != 'curriculum'" class="box">
          <input type="text" placeholder="" v-model="KeyWord" style="
            width:255px;
            height: 48px;
            border: 0px;
            border-radius: 23px;
            position: absolute;
            font-weight: 400;
            color: #666666;
            font-size:16px;
          " />
          <div style="
            cursor: pointer;
            width:22px;
            height:22px;
            float: right;
            margin: 13px 16px 0 0;
            position: relative;
          " @click="search1()">
            <img style="width:100%;height:100%;position: absolute;top: 0;left: 0;" src="../../assets/images/sousuo.png"
              alt="" />
          </div>
        </div>
      </div>
      <div style="width:100%;background-color:#00AEEC  ;"
        v-show="ipt != 'personal' && ipt != 'message_detail' && ipt != 'WXLogin' && ipt != 'replacement_phone'">
        <div class="herder-bt">
          <a :class="ipt == item.Url ? 'li active' : 'li '" v-for="item in date" :key='item.Id' @click="chenkge(item)">
            <span v-if="item.Title === '选课中心'" class="spanPoptip">
              <Poptip trigger="hover" placement="bottom-start">
                {{ item.Title }}
                <span class="span-bt" style="left: -28px;" v-if="ipt == item.Url"></span>
                <div style="width: 600px;overflow: hidden;" slot="content">
                  <div v-for="(v, i) in classify_list" :key="i" :class="options_id == v.Id ? 'herder-bt-content2' : ''"
                    class="herder-bt-content" @click.stop="chenkge2(item, v)">
                    {{ v.Name }}
                  </div>
                </div>
              </Poptip>
            </span>
            <span v-else>
              {{ item.Title }}
              <span class="span-bt" v-if="ipt == item.Url"></span>
            </span>
          </a>
          <!-- <a :class="type == 'shouye' ? 'li active' : 'li '" @click="changeTypeNews()">
                首页
                <span v-if="type == 'shouye'"></span>
              </a>
              <a :class="type == 'keclist' ? 'li active' : 'li '" @click="changeTypeNewskeclist()">选课中心
                <span v-if="type == 'keclist'"></span>
              </a>
              <a :class="type == 'tiku' ? 'li active' : 'li '" @click="changeTypeNewstiku()">医方题库<span
                  v-if="type == 'tiku'"></span></a>
              <a :class="type == 'shiting' ? 'li active' : 'li '" @click="changeTypeNewsshiting()">免费试听<span
                  v-if="type == 'shiting'"></span></a>
              <a :class="type == 'xuexi' ? 'li active' : 'li '" @click="changeTypeNewsxuexi()">网校师资<span
                  v-if="type == 'xuexi'"></span></a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import { jquery } from "jquery";
import md5 from "js-md5";

import "bootstrap";
import "../../../static/js/nav.js";
import "../../../static/js/jquery.aniview.js";
import "../../../static/js/jquery.waypoints.min.js";
import "../../../static/js/jquery.countup.min.js";
import { WOW } from "wowjs";
import "../../../static/js/public.js";

import "../../../static/css/common.css";
// import "../../../static/css/bootstrap.min.css";
import "../../../static/css/nav.css";
import "../../../static/css/animate.min.css";
import "../../../static/css/style.css";
import { name } from "file-loader";

export default {
  data() {
    return {
      sendsystem: false,
      loginstate: false,
      form: {},
      showLogin: false,
      type: "shouye",
      KeyWord: "", //关键字
      ipt: '',
      imgurl: localStorage.getItem("headerImg"),
      realname: localStorage.getItem("realname"),
      info: false,
      date: [],
      thid: 0,
      imgtourl: '../../../static/images/xiaotubiao/头像.png',
      dateurl: '',
      mosturl: '',
      classify_list: [],
      options_id: ""
    };
  },
  mounted() {
    this.$bus.$on('brotherEvent', res => {
      this.imgurl = localStorage.getItem("headerImg");
      this.realname = localStorage.getItem("realname");
    })
    console.log(this.imgurl);
    console.log(this.realname);
    this.get_options();
    this.getbanner();
    this.loginStatus();
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    var that = this;
    window.addEventListener("setItemEvent", function (e) {
      //e.key : 是值发生变化的key
      //例如 e.key==="token";
      //console.log(e)
      //e.newValue : 是可以对应的新值
      if (e.key == "headerImg") {
        //console.log(e.newValue);
        that.imgurl = e.newValue;
      }
      if (e.key == "realname") {
        //console.log(e.newValue);
        that.realname = e.newValue;
      }
    })
    this.getdata()
    var nav = $(".cd-main-header"); //得到导航对象
    var win = $(window); //得到窗口对象
    var sc = $(document); //得到document文档对象。
    win.scroll(function () {
      if (sc.scrollTop() >= 60) {
        nav.addClass("active");
        // $(".navTmp").fadeIn();
      } else {
        nav.removeClass("active");
        // $(".navTmp").fadeOut();
      }
    });
  },
  watch: {
    $route(to, from) {
      this.ipt = to.name;
      if (this.ipt == 'video_detail' || this.ipt == 'detai') {
        this.info = true
      } else {
        this.info = false
      }
      this.loginStatus()
    }
  },
  methods: {
    //获取主目录
    get_options() {
      let posturl = this.$config.baseUrl.pro + "/Api/Client/apiGetTreeExam_ItemBankTypePaged";
      let data = {
        Page: 1,
        Limit: 100,
        ParentId: 1,
        TypeFlag: "classification",
        IsHide: 1,
        IsQchilds: 1
      };
      axios.request({
        url: posturl,
        method: "post",
        data,
        changeOrigin: true
      }).then(resp => {
        if (resp.status == 200) {
          let list = resp.data.Data;
          console.log(list)
          this.classify_list = list;
          if (this.classify_list && this.classify_list.length > 0) {
            if (this.$route.query.Ids) {
              this.options_id = this.$route.query.Ids;
            } else {
              this.options_id = "";
            };
          };
        };
      }).catch(err => {
        // console.log(err);
      });
    },
    //获取背景图
    getbanner() {
      var posturl = this.$config.baseUrl.pro + "/Api/Client/apiGetAllBase_Article";
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          data: {
            Status: 1,
            GroupCode: 'TopHomePage'
          }
        })
        .then((resp) => {
          //console.log(resp);
          this.dateurl = resp.data.Data[0].Img;
          this.mosturl = resp.data.Data[0].Url;
        })
        .catch((err) => {
          //.log(err);
        });
    },
    //跳转
    carousel_click() {
      window.open(this.mosturl, '_blank');
    },
    getdata() {
      var posturl = this.$config.baseUrl.pro + "/Api/Client/apiGetAllBase_Article";
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          data: {
            Status: 1,
            GroupCode: 'MenuNavigation'
          }
        })
        .then((resp) => {
          //console.log(resp, '11111111111111')
          this.date = resp.data.Data.reverse()
          this.thid = this.date[0].Id;
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    quyht() {
      this.$router.push({
        name: 'home',
        query: {
          title: 'home'
        }
      });
    },
    chenkge2(item, v) {
      this.thid = item.Id;
      this.options_id = v.Id;
      console.log(this.$route.name, item.Url);
      this.$router.push({
        name: 'pagevue',
        query: {
          title: item.Url,
          Ids: v.Id
        }
      });
    },
    chenkge(item) {
      if (item.Title !== "选课中心") {
        this.thid = item.Id;
        if (this.classify_list && this.classify_list.length > 0) {
          this.options_id = "";
        };
        localStorage.setItem("metaTitle", item.Title);
        this.$router.push({
          name: 'pagevue',
          query: {
            title: item.Url,
          }
        });
      }
    },
    //跳转到登录页面
    denglu() {
      this.$router.push({
        name: "SignIn",
        query: {
          type: "login"
        }
      });
    },
    grzx() {
      this.$router.push({
        name: "personal"
      })
    },
    //退出登录
    logout() {
      this.$router.push({
        name: "home"
      });
      localStorage.clear();
      location.reload();
      this.sendsystem = false;
    },
    search1() {
      // let pathInfo = this.$router.resolve({
      //   path: "/newsList",
      //   query: {
      //     KeyWord: this.KeyWord,
      //   },
      // });
      // window.open(pathInfo.href, "_blank");
      if (this.ipt == 'curriculum') {

      } else {
        this.$router.push({
          name: "curriculum",
          query: {
            KeyWord: this.KeyWord,
            Id: '选课'
          }
        });
      }
      this.KeyWord = '';
    },
    changeTypeNews() {
      var type = localStorage.getItem("cuoti");
      if (type != undefined && type != null && type != "") {
        if (type == 2) {
          this.$Modal.confirm({
            title: "提示",
            content: "请先交卷"
          });
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "请点击本页面退出按钮退出练习",
          });
        };
      } else {
        this.type = "shouye";
        this.$router.push({
          path: "/home",
          query: {
            title: "home"
          }
        });
      };
    },
    changeTypeNewskeclist() {
      var type = localStorage.getItem("cuoti");
      if (type != undefined && type != null && type != "") {
        if (type == 2) {
          this.$Modal.confirm({
            title: "提示",
            content: "请先交卷"
          });
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "请点击本页面退出按钮退出练习"
          });
        };
      } else {
        this.type = "keclist";
        this.$router.push({
          path: "/curriculum",
          query: {
            title: "curriculum"
          }
        });
      };
    },
    changeTypeNewstiku() {
      //UnopenedQuestionBank
      var type = localStorage.getItem("cuoti");
      if (type != undefined && type != null && type != "") {
        if (type == 2) {
          this.$Modal.confirm({
            title: "提示",
            content: "请先交卷"
          });
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "请点击本页面退出按钮退出练习"
          });
        };
      } else {
        this.type = "tiku";
        this.$router.push({
          path: "/question",
          query: {
            title: "question"
          }
        });
      };
    },
    changeTypeNewsshiting() {
      var type = localStorage.getItem("cuoti");
      if (type != undefined && type != null && type != "") {
        if (type == 2) {
          this.$Modal.confirm({
            title: "提示",
            content: "请先交卷"
          });
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "请点击本页面退出按钮退出练习"
          });
        };
      } else {
        this.type = "shiting";
        this.$router.push({
          name: "AudioVisualZone",
          query: {
            type: "AudioVisualZone"
          }
        });
      }
    },
    changeTypeNewsxuexi() {
      var type = localStorage.getItem("cuoti");
      if (type != undefined && type != null && type != "") {
        if (type == 2) {
          this.$Modal.confirm({
            title: "提示",
            content: "请先交卷"
          });
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "请点击本页面退出按钮退出练习"
          });
        };
      } else {
        this.type = "xuexi";
        this.$router.push({
          path: "/onlineschool",
          query: {
            title: "onlineschool"
          }
        });
        // this.$router.push({
        //   name: "learningTools",
        //   query: {
        //     type: "learningTools",
        //   },
        // });
      };
    },
    ///登录状态判断
    loginStatus() {
      var token = localStorage.getItem("authToken");
      //登录了
      if (
        token !== null &&
        token !== undefined &&
        token !== ""
      ) {
        //console.log(localStorage.getItem("realname"), '11111111111111111')
        this.sendsystem = true;
        //his.getConfig();
      } else {
        this.sendsystem = false;
        //this.Cancellation();
      };
    },
    //注册功能
    Cancellation() {
      this.$router.push({
        path: "/register",
        query: {
          title: "register"
        }
      });
    },
    selectQuest() {
      //console.log(0);
    },
    menuclick(type) {
      // console.log(type);
      this.$router.push({
        name: "newslist"
      });
    },
    //登录

    dianji() {
      if (this.isMobiles() != null) {
        //alert(this.isMobiles());
        event.preventDefault();
        if ($(".cd-main-content").hasClass("nav-is-visible")) {
          this.closeNav();
          $(".cd-overlay").removeClass("is-visible");
        } else {
          $(this).addClass("nav-is-visible");
          $(".cd-primary-nav").addClass("nav-is-visible");
          $(".cd-main-header").addClass("nav-is-visible");
          $(".cd-main-content")
            .addClass("nav-is-visible")
            .one(
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
              function () {
                $("body").addClass("overflow-hidden");
              }
            );
          toggleSearch("close");
          $(".cd-overlay").addClass("is-visible");
        };
      };
    },
    dianjixiazai() {
      if (this.isMobiles() != null) {
        //alert(this.isMobiles());
        event.preventDefault();
        if ($(".cd-main-content").hasClass("nav-is-visible")) {
          this.closeNav();
          $(".cd-overlay").removeClass("is-visible");
        } else {
          $(this).addClass("nav-is-visible");
          $(".cd-primary-nav").addClass("nav-is-visible");
          $(".cd-main-header").addClass("nav-is-visible");
          $(".cd-main-content")
            .addClass("nav-is-visible")
            .one(
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
              function () {
                $("body").addClass("overflow-hidden");
              }
            );
          toggleSearch("close");
          $(".cd-overlay").addClass("is-visible");
        };
      };
      let link = document.createElement("a"); // 创建a标签
      link.style.display = "none";
      link.href = "谷歌浏览器下载.rar"; // 设置下载地址
      link.setAttribute("download", ""); // 添加downLoad属性
      document.body.appendChild(link);
      link.click();
    },
    closeNav() {
      $(".cd-nav-trigger").removeClass("nav-is-visible");
      $(".cd-main-header").removeClass("nav-is-visible");
      $(".cd-primary-nav").removeClass("nav-is-visible");
      $(".has-children ul").addClass("is-hidden");
      $(".has-children a").removeClass("selected");
      $(".moves-out").removeClass("moves-out");
      $(".cd-main-content")
        .removeClass("nav-is-visible")
        .one(
          "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          function () {
            $("body").removeClass("overflow-hidden");
          }
        );
    },
    isMobiles() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>
<style scoped>
.herder-bt-content {
  float: left;
  font-size: 16px;
  line-height: 30px;
  margin: 5px;
  border: #fff 1px solid;
  color: #00AEEC;
  border-radius: 15px;
  height: 30px;
  padding: 0 10px;
  font-weight: 400;
}

.herder-bt-content:hover {

  border-color: #00AEEC;
}

.herder-bt-content2 {
  color: #fff;
  background-color: #00AEEC;
}

.header {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  background: #fff;
  line-height: 80px;
}

.herder-bt {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  background: #00AEEC;
  line-height: 60px;
}

.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

}

.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom
}

.spn {
  display: inline-block;
  width: 73px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 50px;
}

.headerright>>>.el-button.is-round {
  padding: 8px 30px !important;
}

.herder-bt .li {
  width: 140px;
  height: 60px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  display: inline-block;
  position: relative;
}

.herder-bt .li span.span-bt {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 140px;
  height: 3px;
  background: #fff
}

.headerright {
  width: 400px;
  height: 48px;
  float: right;
  margin-top: 16px;
  margin-left: 30px;
}

.ivu-input {
  height: 44px !important;
  border: 0rem solid #dcdee2 !important;
}

.box {
  width: 310px;
  height: 48px;
  padding-left: 16px;
  position: relative;
  overflow: hidden;
  border-radius: 23px;
  border: 1px solid #00AEEC;
  float: right;
  margin-top: 16px;
}

.active {
  font-weight: bold !important;
}
</style>


// WEBPACK FOOTER //
// src/components/webTop/webTopMenu.vue